<script>
  import axios from "axios"
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import notify from "../../../../../Script/notify"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import BadgePublish, { updateBadgePublish } from "../../Stores/badge"
  import Header from "../../Components/header.svelte"
  import Table from "../../../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import Filter from "../../../../../Shared/filter.svelte"
  import { fetchBadgeTempList, initiateDocument } from "../../Script/api"
  import ApplicationState from "../../../../../Stores/applicationStates"
  // import DocDropdown from "../../.../../../../../Shared/dropDown2.svelte"
  import DocDropdown from "../../../../../Shared/scrollableDropdown.svelte"
  import TemplatesList from "../../../../../Stores/templatesList"
  import { loadImage } from "../../../../Templates/File/Edit/Script/loadImg"
  import { validateFile } from "../../../BulkUpload/Script/bulkUpload"
  import InfoModel from "./Components/infoModel.svelte"
  import { sleep } from "../../../../../Script/sleep"
  import BgRemovalModal from "../../../../../Shared/BgRemoval/index.svelte"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoader = true
  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Fetching badge templates"
  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page = 1

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {Object} - it consists response of badge template fetch api
   */
  let docTempdata = {
    templates: [],
  }

  /**
   * @type {String} - what type of sort applied
   */
  let sortBy

  /**
   * @type {String} - what type of sort applied
   */
  let findPageRefreshed = false

  /**
   * @type {String} - selected badge template
   */
  let selectedBadge = {}

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @type {Boolean} - upload are whether to show or not
   */
  let uploadNewBadge = false

  let showBgRemovalModal = false

  let showConfirmModel = false
  /**
   * Assign initial values
   */
  onMount(async () => {
    setTimeout(async () => {
      try {
        showLoader = true
        query = queryStringToJSON($querystring)
        $BadgePublish.reference = ""
        limit = query.limit ? query.limit : 12
        page = query.page ? query.page : 1
        sort = query.sort ? query.sort : -1
        sortBy = query.sortBy ? query.sortBy : "date"
        if (query.sdate) startDate = query.sdate
        if (query.edate) endDate = query.edate
        if (query.sname) search.searchvalue = query.sname
        if (!findPageRefreshed) await handleBadgeListFetch()
      } catch (error) {
        const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: onMount"
        notify.danger(error, info)
      } finally {
        showLoader = false
      }
    }, 100)
  })

  const handleBadgeListFetch = async () => {
    try {
      let queryStr = `?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`

      docTempdata = await fetchBadgeTempList(queryStr)

      push(`/publish/badge/badgetemplate?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      showLoader = true

      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await handleBadgeListFetch()
    } catch (error) {
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    } finally {
      showLoader = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      showLoader = true
      limit = 12
      page = 1
      sort = -1
      search.searchvalue = ""
      startDate = null
      endDate = null
      await handleBadgeListFetch()
    } catch (error) {
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    } finally {
      showLoader = false
    }
  }

  /**
   * @type {emailNotify}
   */
  let emailNotify = {
    close() {},
  }

  // let newDocument = true

  const badgeUpload = async () => {
    try {
      $BadgePublish.reference = $BadgePublish.reference.trim()

      if (!$BadgePublish.reference) throw "Badge name is mandatory"
      if (!$BadgePublish.domain) throw "Domain is mandatory"

      // if (!new URL($BadgePublish.domain).hostname) {
      //   $BadgePublish.domain = ""
      //   emailNotify = notify.danger("Enter Valid domain name. example (print2block.com)")
      //   return
      // }

      // if (newDocument) {
      showLoading = true
      let apiData = await initiateDocument()
      $BadgePublish.documentId = apiData.documentID
      // }

      let obj = {
        documentID: $BadgePublish.documentId,
        domain: $BadgePublish.domain,
        name: $BadgePublish.reference,
        image: selectedBadge.uri.replaceAll("/ipfs/", ""),
      }

      const data = await uploadBadgeApi(obj)
      updateBadgePublish($BadgePublish)

      push(`/publish/badge/doctemplate?documentId=${$BadgePublish.documentId}&badgeId=${data.id}`)
      // if (newDocument) push(`/publish/badge/doctemplate?documentId=${$BadgePublish.documentId}&badgeId=${data.id}`)
      // else push(`/documents/badge/details?documentId=${$BadgePublish.documentId}&badgeId=${data.id}`)

      updateBadgePublish($BadgePublish)
    } catch (error) {
      emailNotify.close()
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Error occurred while creating badge."
      emailNotify = notify.danger(error, info)
    }
  }

  const uploadBadgeApi = (body) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

        // Fetching list of document templates
        const { data } = await axios.post(`/api/swagger/v2/badge/`, body, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        // Check if the response has an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode // Throw the error code
        }

        // console.log(data)

        $BadgePublish.badgeId = data.badge.id

        // console.log($BadgePublish)

        resolve(data.badge)
      } catch (error) {
        reject(error)
      }
    })
  }

  let showLoading = false

  /**
   * @type {invalidFileNotify}
   */
  let invalidFileNotify = {
    close() {},
  }

  let imageLoading = false

  let uploadedFile

  const UploadFile = async (e) => {
    try {
      imageLoading = true
      invalidFileNotify.close()

      // Check if the file type is neither PDF nor image
      uploadedFile = await validateFile(e.target.files[0])

      if (uploadedFile.size > 2097152) throw "File Size exceeded"

      let uri = URL.createObjectURL(uploadedFile)
      let badgeImg = await loadImage(uri)

      if (badgeImg.width > 1024 || badgeImg.height > 1024) throw "File dimensions exceeded"

      selectedBadge.uri = uri

      selectedBadge.fileName = uploadedFile.name
      // console.log(data)
    } catch (error) {
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Error occurred while uploading own badge design."
      invalidFileNotify = notify.danger(error, info)
    } finally {
      imageLoading = false
    }
  }

  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialChars = async (e) => {
    const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Invalid character validation for the badge name during onBlur/ onPaste/ onKeypress"
    try {
      // Destructure the type and key properties from the event object
      let { type, key } = e
      closeNotification.close()

      // console.log(type)

      // Regular expression to match allowed characters
      let allowedCharsRegex = /^[A-Za-z0-9\s-()+&@.,]+$/
      // Check if it's a keypress event and the pressed key is not allowed
      if (type === "keypress") {
        if ($BadgePublish.reference.length > 50) exceedsmaxCharacters()

        if (!allowedCharsRegex.test(key)) {
          e.preventDefault()

          $BadgePublish.reference += key

          closeNotification.close()

          // Prevent the default keypress behavior if the pressed key is not allowed
          // Show a danger notification indicating the allowed characters
          closeNotification = notify.danger("Only letters, numbers, and special characters -()+&@., are allowed.", info)
          // if (!allowedCharsRegex.test(key) && $BadgePublish.reference.length <= 50) closeNotification = notify.danger("Only letters, numbers, and special characters -()+&@., are allowed.")
          // if ($BadgePublish.reference.length > 50) closeNotification = notify.info(`Badge name should not be more than 50 characters`)
          setTimeout(() => {
            // if (!allowedCharsRegex.test(key) || $BadgePublish.reference.length > 50) $BadgePublish.reference = $BadgePublish.reference.slice(0, -1)
            $BadgePublish.reference = $BadgePublish.reference.slice(0, -1)

            // if (!$BadgePublish.reference) $BadgePublish.reference = ""
          }, 100)
        }
      } else if (type === "paste") {
        // Get the pasted text from the clipboard
        let clipboardData = e.clipboardData || window.clipboardData
        let pastedText = clipboardData.getData("text/plain")

        setTimeout(() => {
          closeNotification.close()
          // Check if the pasted text contains any invalid special characters
          if (!allowedCharsRegex.test(pastedText)) {
            // Remove any characters that are not allowed
            let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&@.,]/g, "").trim()

            // Check if the sanitized text is the same as the original pasted text
            if (sanitizedText !== pastedText) {
              closeNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&@., are allowed.", info)
            }

            // Set the input value to the sanitized text
            $BadgePublish.reference = sanitizedText
          }
          if (!$BadgePublish.reference) $BadgePublish.reference = ""
          if ($BadgePublish.reference && $BadgePublish.reference.length > 50) exceedsmaxCharacters()
        }, 500)
      } else if (type === "blur") {
        closeNotification.close()
        $BadgePublish.reference = $BadgePublish.reference.trim()

        // Check if the pasted text contains any invalid special characters
        if (!allowedCharsRegex.test($BadgePublish.reference)) {
          // Remove any characters that are not allowed
          let sanitizedText = $BadgePublish.reference.replace(/[^A-Za-z0-9\s-()+&@.,]/g, "").trim()

          // Check if the sanitized text is the same as the original pasted text
          if (sanitizedText !== $BadgePublish.reference) {
            closeNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&@., are allowed.", info)
          }

          // Set the input value to the sanitized text
          $BadgePublish.reference = sanitizedText
        }
        if ($BadgePublish.reference && $BadgePublish.reference.length > 50) exceedsmaxCharacters()
      }
    } catch (error) {
      notify.danger(error, info)
    }
  }

  const exceedsmaxCharacters = () => {
    try {
      closeNotification.close()

      setTimeout(() => {
        $BadgePublish.reference = $BadgePublish.reference.slice(0, 50)
      }, 100)

      closeNotification = notify.info(`Badge name should not be more than 50 characters`)
    } catch (error) {
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Maximum count validation for the badge name during onBlur/ onPaste/ onKeypress"
      closeNotification = notify.danger(error, info)
    }
  }

  const domainNameValidation = async (e) => {
    try {
      // console.log($BadgePublish.domain)

      // closeNotification.close()
      let { type, key } = e
      let dominePattern = /^[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
      if (!$BadgePublish.domain) $BadgePublish.domain = ""
      // $BadgePublish.domain = new URL(pastedText).hostname

      // onKeypress
      if (type === "keypress") {
        await exceedsmaxDomainCharacters($BadgePublish.domain)
      }

      // onPaste
      if (type === "paste") {
        let clipboardData = e.clipboardData || window.clipboardData
        let pastedText = clipboardData.getData("text/plain")
        pastedText = pastedText.trim()
        if (!pastedText) return
        await sleep(500)

        $BadgePublish.domain = validateDomainValue(pastedText.trim())
        // console.log($BadgePublish.domain)

        $BadgePublish.domain = $BadgePublish.domain.trim()
        if (!dominePattern.test($BadgePublish.domain.trim())) {
          $BadgePublish.domain = ""
          throw `Enter Valid domain name. example (print2block.com)`
        }

        await exceedsmaxDomainCharacters($BadgePublish.domain)
      }

      // onBlur
      if (type === "blur") {
        e.target.value = e.target.value.trim()
        if (!e.target.value) return

        $BadgePublish.domain = validateDomainValue(e.target.value.trim())

        if ($BadgePublish.domain && !dominePattern.test($BadgePublish.domain.trim())) {
          $BadgePublish.domain = ""
          throw `Enter Valid domain name. example (print2block.com)`
        }
        await exceedsmaxDomainCharacters($BadgePublish.domain)
      }
    } catch (error) {
      closeNotification.close()
      // console.error(error)
      if (typeof error == "string" && error.includes(":")) closeNotification = notify[error.split(":")[0]](error.split(":")[1])
      else {
        const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Domain name validation during onBlur/ onPaste/ onKeypress"
        closeNotification = notify.danger(error, info)
      }
    }
  }

  const validateDomainValue = (value) => {
    try {
      if (value.includes("https://")) value = value.replaceAll("https://", "")
      if (value.includes("http://")) value = value.replaceAll("http://", "")
      if (value.includes("/")) value = value.split("/")[0]
      return value
    } catch (error) {
      throw error
    }
  }

  const exceedsmaxDomainCharacters = async (value) => {
    try {
      if (value.length > 50) {
        await sleep(200)

        $BadgePublish.domain = value.slice(0, 50)
        throw `info:Domain name should not be more than 50 characters`
      }
    } catch (error) {
      throw error
    }
  }

  const handleBgRemoval = async (e) => {
    try {
      showBgRemovalModal = false
      showLoader = true
      msg = "Removing Background"

      uploadedFile = new File([e.detail], selectedBadge.fileName, {
        type: "image/png",
      })

      selectedBadge.uri = URL.createObjectURL(uploadedFile)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: During background removal of the uploaded own badge design"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      msg = "Fetching Badge Templates"
    }
  }

  const handleAssetAddition = async () => {
    try {
      showLoader = true
      msg = "Uploading Badge"

      const { data } = await axios.post(
        "/api/swagger/v2/misc/assets",
        {
          file: uploadedFile,
          resource: query.documentId,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": $ApplicationState.token,
          },
        }
      )
      if (data.error && !data.success) throw data.errorCode

      selectedBadge.uri = data.asset.uri

      uploadNewBadge = false
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: While updating the own badge design to ipfs"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      msg = "Fetching Badge Templates"
    }
  }
</script>

<svelte:window
  on:load={() => {
    // findPageRefreshed = true
    // push(`/publish/badge`)
  }}
/>

<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

{#if showBgRemovalModal}
  <BgRemovalModal
    blobURL={selectedBadge.uri}
    on:click={() => {
      showBgRemovalModal = false
    }}
    on:removeBg={handleBgRemoval}
  />
{/if}

{#if showConfirmModel}
  <InfoModel on:continue={badgeUpload} on:click={() => (showConfirmModel = false)} domain={$BadgePublish.domain} />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="mx-auto h-auto w-full max-w-[920px] px-6 pb-40 pt-6 lg:px-0">
    <Header title="{uploadNewBadge ? 'Upload Badge' : !uploadNewBadge && !Object.keys(selectedBadge).length ? 'Upload or Select Badge' : 'Badge Details'} " bind:showLoader bind:msg releaseBtn={false} />
    <div class="relative flex min-h-[470px] w-full flex-col justify-between gap-3 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
      <!-- <div class="h-full space-y-3"> -->
      {#if uploadNewBadge}
        <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">To proceed with the publishing process, it is required that you upload your own badge design to ensure the process is completed successfully.</p>

        {#if !selectedBadge.uri}
          <div class="relative mx-auto mt-6 flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-12 hover:border-gray-200/50 hover:bg-[#f7f7f7] disabled:cursor-not-allowed hover:dark:bg-bodyblack sm:w-1/2">
            <!-- <div class="relative flex h-full w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 p-3 hover:border-gray-200/50 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack"> -->
            <input disabled={imageLoading} on:change={UploadFile} name="signature" id="signature" type="file" accept=".png, .jpeg, .jpg" class="absolute inset-0 cursor-pointer opacity-0" />
            <div class="text-xl text-blue-500 lg:text-3xl">
              <i class="fa-solid fa-cloud-arrow-up" />
            </div>
            <span class="md:txet-base select-none text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload</span>
            <span class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum Size 2MB</span>
            <span class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum image dimensions 1024px x 1024px</span>
            <span class="select-none text-center text-xs font-normal text-blue-500 md:text-sm">Supported formats: IMAGE only.</span>
          </div>
        {:else}
          <div class="flex flex-col items-center justify-center gap-3">
            <div class="flex h-full w-fit items-center">
              <div class="relative h-auto overflow-hidden rounded-md">
                <button
                  disabled={imageLoading}
                  on:click={() => {
                    selectedBadge.uri = ""
                  }}
                  type="button"
                  class="absolute right-3 top-2 text-xl text-red-500 hover:text-red-600 disabled:cursor-not-allowed"
                >
                  <i class="fa-solid fa-circle-xmark" />
                </button>
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img src={selectedBadge.uri} class="aspect-auto h-auto max-h-60" alt="signatory image" style="background: url(assets/img/grid.png);" />
              </div>
            </div>

            <button
              on:click={() => {
                showBgRemovalModal = true
              }}
              type="button"
              class="w-fit rounded-md bg-blue-600 py-2 px-4 text-sm font-bold text-white"
            >
              <span>
                <i class="fa-solid fa-eraser" />
              </span>
              &nbsp;&nbsp;Remove Background
            </button>
          </div>
        {/if}
        <div class="flex items-center justify-end gap-3">
          <button
            on:click={() => {
              selectedBadge = {}
              uploadNewBadge = false
            }}
            type="button"
            class="flex h-9 w-auto min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 hover:text-white focus:outline-none active:bg-yellow-500 disabled:cursor-not-allowed disabled:bg-yellow-300 md:w-32 lg:px-4"
          >
            <i class="fa-solid fa-rotate-left" />

            <span class="select-none md:block">&nbsp;Choose&nbsp;Badge&nbsp;&nbsp;</span>
          </button>
          <button on:click={handleAssetAddition} disabled={!selectedBadge.uri} type="button" class="flex h-9 w-auto min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4">
            <span class="select-none md:block">&nbsp;Next&nbsp;&nbsp;</span>
            <i class="fa-solid fa-angle-right" />
          </button>
        </div>
      {:else if !uploadNewBadge && !Object.keys(selectedBadge).length}
        <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">To proceed with the publishing process, it is required that you either select an existing badge or upload a new one to ensure the process is completed successfully.</p>
        <div class="w-full select-none space-y-3 text-lg font-bold text-black dark:text-white sm:text-2xl">
          <div class="">Upload your own badge design</div>

          <button on:click={() => (uploadNewBadge = true)} type="button" class="mx-auto flex h-9 w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 lg:px-4">
            <i class="fa-solid fa-upload" />
            <span>&nbsp;&nbsp;Upload&nbsp;badge</span>
          </button>
        </div>
        <p class="py-3 text-center text-xl dark:text-[#ff6a00]">(or)</p>
        <div class="relative">
          <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title="Choose from Templates" filterComponent={Filter} filter={true} jsonData={docTempdata.templates ? docTempdata.templates : []} entriesList={[12, 60, 120]} count={docTempdata.count}>
            <!-- List component -->
            <div class="flex w-full flex-wrap">
              {#if docTempdata.templates.length}
                {#each docTempdata.templates as json, i}
                  <div class="h-[290px] w-1/2 p-1 mobile:w-1/3 md:w-1/4">
                    <List
                      selectedBadgeId={selectedBadge.id}
                      {json}
                      on:click={() => {
                        selectedBadge = json
                      }}
                    />
                  </div>
                {/each}
              {:else}
                <div class="text-secondary2 w-full select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no Badge template</div>
              {/if}
            </div>
          </Table>
        </div>

        {#if docTempdata.templates && !docTempdata.templates.length}
          <div class="flex w-full justify-end">
            <a href="#/templates/badge/edit?id=000000000000000000000000" type="button" class="flex h-9 w-fit min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
              <i class="fa-solid fa-plus" />
              <span class="select-none md:block">&nbsp;Create&nbsp;badge&nbsp;Template&nbsp;&nbsp;</span>
            </a>
          </div>
        {/if}
      {:else}
        <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">To proceed with the publishing process, it is required that you fill the below data to ensure the process is completed successfully.</p>
        <div class="flex h-full w-full flex-col gap-3 md:flex-row">
          <div class="relative flex h-auto items-center justify-center overflow-hidden rounded-md bg-[#f7f7f7] p-3 dark:bg-bodyblack md:w-1/3">
            <button
              on:click={() => {
                selectedBadge = {}
              }}
              type="button"
              class="absolute right-3 top-2 text-xl text-red-500 hover:text-red-600 disabled:cursor-not-allowed"
            >
              <i class="fa-solid fa-circle-xmark" />
            </button>
            <img src={selectedBadge.uri} alt="Badge" class="aspect-auto max-h-[400px] w-auto max-w-full select-none rounded-md" style="background: url(assets/img/grid.png);" />
          </div>
          <div class="flex w-full flex-col justify-between gap-3 md:w-2/3">
            <div class="space-y-6">
              <div class="space-y-2">
                <p class="text-sm text-gray-200 mobile:font-medium">{selectedBadge.fileName ? "Uploaded badge name" : "Badge template name"}</p>
                <div class="truncate px-3 text-sm font-bold text-gray-800 dark:text-white sm:text-lg">{selectedBadge.name || selectedBadge.fileName}</div>
              </div>

              <div class="w-full space-y-2">
                <p class="text-sm text-gray-200 mobile:font-medium">Badge Name</p>
                <input required bind:value={$BadgePublish.reference} on:blur={checkSpecialChars} on:keypress={checkSpecialChars} on:paste={checkSpecialChars} placeholder="Enter details about badge" class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
              </div>

              <div class="w-full space-y-2">
                <p class="text-sm text-gray-200 mobile:font-medium">Lock to Domain</p>
                <input required on:keypress={domainNameValidation} on:paste={domainNameValidation} on:blur={domainNameValidation} bind:value={$BadgePublish.domain} placeholder="Enter Domain" class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
              </div>
            </div>

            <div class="flex flex-col justify-end gap-3 mobile:flex-row">
              <button on:click={() => (selectedBadge = {})} type="button" class="flex h-9 w-auto min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 hover:text-white focus:outline-none active:bg-yellow-500 md:w-32 lg:px-4">
                <i class="fa-solid fa-rotate-left" />
                <span class="select-none md:block">&nbsp;Choose&nbsp;another&nbsp;badge&nbsp;&nbsp;</span>
              </button>

              <!-- {#if !newDocument}
                <button on:click={badgeUpload} disabled={!$BadgePublish.domain || !$BadgePublish.reference} type="button" class="flex h-9 w-auto min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4">
                  <i class="fa-solid fa-check" />
                  <span class="select-none md:block">&nbsp;Link&nbsp;Badge&nbsp;with&nbsp;Document&nbsp;&nbsp;</span>
                </button>
              {:else} -->
              <button
                on:click={() => {
                  try {
                    closeNotification.close()
                    $BadgePublish.domain = $BadgePublish.domain.trim()
                    if (!$BadgePublish.domain) throw "Domain name should be mandatory"
                    if (!selectedBadge.uri.includes("/ipfs/")) throw "There was an issue with the image file. Kindly try uploading the badge again"
                    showConfirmModel = true
                  } catch (error) {
                    const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Domain name validation whether its empty or not during confirmation before badge creation"
                    closeNotification = notify.danger(error, info)
                  }
                }}
                disabled={!$BadgePublish.domain || !$BadgePublish.reference}
                type="button"
                class="flex h-9 w-auto min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4"
              >
                <i class="fa-solid fa-check" />
                <span class="select-none md:block">&nbsp;&nbsp;Confirm&nbsp;</span>
              </button>
              <!-- {/if} -->
            </div>
          </div>
        </div>
      {/if}
      <!-- </div> -->

      {#if showLoader}
        <LoadingScreen {msg} />
      {/if}
    </div>
  </div>
  <Footer />
</div>
